module.exports = __webpack_public_path__ + "static/media/cap1-02-mob.11e14fe5.png";